export const QUEUE_NAME_FOR_REVIEW = "To Review";
export const QUEUE_NAME_FOR_REVIEWED = "Reviewed";

export const GOOGLE_CLIENT_ID = "70384775898-5bu01f5snei5rgon0d93io9rpblt242m.apps.googleusercontent.com";

export const ADD_ACCOUNT_DESCRIPTION_ONBOARDING = "Let's start by connecting your accounts where most of the spending happens.\n" + 
    "Securly give SplitzUp read-only access to your accounts. "
export const ADD_ACCOUNT_DESCRIPTION_SETTINGS = "Connect your accounts where most of the spending happens.\n" + 
    "Securly give SplitzUp read-only access to your accounts. "